<template>
    <button
      class="retenidoBtn"
      v-if="amount != 0"
      v-on="on"
      v-bind="attrs"
      @click="$emit('click')"
    >
      Saldo retenido $ {{ amount }}
    </button>
</template>

<script>
export default {
  name: 'SaldoRetenidoButton',
  props: {
    amount: {
      type: [Number, String],
      required: true
    }
  }
};
</script>

<style scoped>
button.retenidoBtn {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #FF8A00;
  font-weight: 500;
  transition: color 0.15s, box-shadow 0.15s, background 0.15s;
  text-decoration: underline;
}

button.retenidoBtn:hover,
button.retenidoBtn:focus-visible {
  color: #D04B14;
  text-decoration: underline;
  box-shadow: 0 2px 8px rgba(255, 138, 0, 0.06);
  outline: none;
}

button.retenidoBtn:active {
  color: #FF8A00;
  background: #ffe7c0;
}

</style>
